var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66797 17.4154L6.96077 18.1224L7.66787 18.8297L8.37508 18.1225L7.66797 17.4154ZM24.4235 1.65979C24.4235 1.10751 23.9758 0.65979 23.4235 0.65979L14.4235 0.65979C13.8713 0.65979 13.4235 1.1075 13.4235 1.65979C13.4235 2.21207 13.8713 2.65979 14.4235 2.65979L22.4235 2.65979V10.6598C22.4235 11.2121 22.8713 11.6598 23.4235 11.6598C23.9758 11.6598 24.4235 11.2121 24.4235 10.6598V1.65979ZM0.714671 11.8746L6.96077 18.1224L8.37517 16.7083L2.12908 10.4605L0.714671 11.8746ZM8.37508 18.1225L24.1306 2.3669L22.7164 0.952683L6.96086 16.7083L8.37508 18.1225Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d6ac6f10e8618f3e1fbbd998b6bf2df3.svg";
export { ForwardRef as ReactComponent };